import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { normalizePollCode } from '../../utils/pollUtils';

interface FindPollProps {
  onFind: (pollCode: string) => void;
}

export function FindPoll({ onFind }: FindPollProps) {
  const [pollCode, setPollCode] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (pollCode.trim()) {
      onFind(normalizePollCode(pollCode));
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-md">
      <div className="relative">
        <input
          type="text"
          value={pollCode}
          onChange={(e) => setPollCode(e.target.value)}
          placeholder="Enter poll code"
          className="w-full px-4 py-2 pr-12 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100 dark:placeholder-gray-400"
          maxLength={4}
        />
        <button
          type="submit"
          className="absolute right-2 top-1/2 -translate-y-1/2 p-2 text-gray-400 hover:text-blue-500 dark:text-gray-300 dark:hover:text-blue-400"
        >
          <Search className="w-5 h-5" />
        </button>
      </div>
    </form>
  );
}